module.exports = __webpack_public_path__ + "media/components/common/formParts/icons/Add-b6be4b84054cd8bfb7ea0470c1f35dc9.svg";